export function isEncryptedTaylorPayload(value) {
  const payload = String(value || "").trim();
  if (!payload) return false;
  if (payload.startsWith("{")) {
    try {
      const parsed = JSON.parse(payload);
      return Boolean(
        parsed &&
        typeof parsed.iv === "string" &&
        parsed.iv.trim() &&
        typeof parsed.data === "string" &&
        parsed.data.trim()
      );
    } catch {
      return false;
    }
  }
  const parts = payload.split(":");
  return parts.length === 2 && parts[0]?.trim() && parts[1]?.trim();
}

export async function postTaylorFormImport(baseUrlNormalized, token, importPath, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("showInAdminTable", "true");
  formData.append("source", "admin-ui");
  formData.append("isEncrypted", "true");
  const url = `${baseUrlNormalized}/api/${importPath.replace(/^\//, "")}`;
  const res = await fetch(url, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  return { ok: res.ok && data.success, data, res };
}
